import { LitElement, html, css } from '@hh/global.js'

export class HHAccordion extends LitElement {
  static properties = {
    button: { state: true },
    content: { state: true },
    slot: { state: true },
  }

  firstUpdated() {
    super.firstUpdated()
    this.maxHeight = this.getAttribute('max-height')
    this.initAccordion()
  }

  initAccordion() {
    this.slot = this.shadowRoot.querySelector('slot')
    for (const child of this.slot.assignedElements()) {
      if (child.tagName === 'BUTTON') {
        this.button = child
      } else {
        this.content = child
      }
    }

    this.initAccordionAction()
  }

  initAccordionAction() {
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        this.button.classList.toggle('active')
        this.currentAriaExpanded = this.button.getAttribute('aria-expanded')
        if(this.currentAriaExpanded === 'true') {
          this.button.setAttribute('aria-expanded', 'false')
        } else {
          this.button.setAttribute('aria-expanded', 'true')
        }

        if (this.content.style.maxHeight) {
          this.content.style.display = "none"
          this.content.style.maxHeight = null
        } else {
          this.content.style.display = "block"
          this.content.style.maxHeight = this.maxHeight ?? `${this.content.scrollHeight}px`
        }
      })
    }
  }

  render() {
    return html`
      <div class="accordion-wrapper">
        <slot></slot>
      </div>
    `
  }
}

customElements.define('hh-accordion', HHAccordion)
